import React, { Component } from "reactn";
import { Fragment } from "react";
import { Button, IconButton, Menu, Icon, MenuList, Popover } from "@material-ui/core";
import { getStaticUrl } from "js/config";
import { ds } from "js/core/models/dataService";
import classNames from "classnames";
import styled from "styled-components";
import { themeColors } from "js/react/sharedStyles";
import { Gap5 } from "js/react/components/Gap";

export const UIContainerContext = React.createContext(true);

export class UIContainer extends Component {
    state = {
        shouldRender: true,
        isOpening: false
    };

    constructor() {
        super();
        this.containerRef = React.createRef();
    }

    componentDidMount() {
        ds.selection.element = null;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.isOpen && !this.props.isOpen) {
            this.props.onClose();
        }
    }

    render() {
        if (this.state.shouldRender) {
            return (
                <UIContainerContext.Provider value={this.state.isOpening}>
                    <div ref={this.containerRef}
                        className={`beautiful-ui ui-container ${this.props.direction} ${this.props.className}`}>
                        {this.props.children}
                    </div>
                </UIContainerContext.Provider>
            );
        } else {
            return null;
        }
    }
}

export class UIPane extends Component {
    render() {
        return (
            <div {...this.props} className={`ui-pane ${this.props.className || ""}`}>
                {this.props.children}
            </div>
        );
    }
}

export class UIPaneWithSideBar extends Component {
    render() {
        return (
            <div {...this.props} className={`ui-pane with-sidebar ${this.props.className || ""}`}>
                {this.props.children}
            </div>
        );
    }
}

export class UIPaneHeader extends Component {
    render() {
        return (
            <div className={`ui-pane-header ${this.props.className}`}>
                <Fragment>{this.props.children}</Fragment>
                {
                    this.props.onClose &&
                    <IconButton className="exit-button" onClick={this.props.onClose}>
                        <Icon>close</Icon>
                    </IconButton>
                }
            </div>
        );
    }
}

export class UIPaneSideBar extends Component {
    render() {
        const show = this.props.show ? "show" : null;
        return (
            <div
                className={`ui-pane-sidebar ${show}`}
                onClick={e => {
                    e.stopPropagation();
                    this.props.onHide && this.props.onHide();
                    console.log("ui-pane-sidebar");
                }}
            >
                <div
                    className="panel"
                    style={this.props.style}
                    onClick={e => e.stopPropagation()}
                >{this.props.children}</div>
            </div>
        );
    }
}

export class UIPaneContents extends Component {
    render() {
        return (
            <div className="ui-inner-pane" onScroll={this.props.onScroll} style={this.props.style}>
                {this.props.children}
            </div>
        );
    }
}

export class UINavigation extends Component {
    static contextType = UIContainerContext;

    render() {
        let onSelect = event => {
            this.props.onSelect(event.currentTarget.id);
        };

        return (
            <div className={`ui-navigation ${this.props.className || ""} animate-in`}>
                <div
                    className="ui-navigation-back-button"
                    onClick={() => {
                        if (!this.context) {
                            this.props.onBack();
                        }
                    }}
                >
                    <img src={getStaticUrl("/images/backIcon.svg")}/>
                </div>
                <div className={"ui-navigation-items " + (this.props.fullHeight ? "full-height" : "")}>
                    {React.Children && React.Children.map(this.props.children, child => {
                        if (child) {
                            return React.cloneElement(child, {
                                key: child.props.id,
                                selected: this.props.selected,
                                onSelect: onSelect
                            });
                        }
                    })}
                </div>
            </div>
        );
    }
}

export class UINavigationItemHeader extends Component {
    render() {
        return (
            <div className={"ui-navigation-item-header " + (this.props.fullHeight ? "full-height" : "")}>
                {this.props.title && (
                    <span className="title">{this.props.title}</span>
                )}
                {React.Children.map(this.props.children, child => {
                    if (child) {
                        return React.cloneElement(child, {
                            selected: this.props.selected,
                            onSelect: this.props.onSelect,
                        });
                    }
                })}
            </div>
        );
    }
}

export class UINavigationItem extends Component {
    render() {
        let selected = this.props.selected == this.props.id;
        //if there is a custom select on UINavigationItem use that otherwise use onSelect from UINavigation
        const handleClick = this.props.onCustomSelect || this.props.onSelect;

        return (
            <div
                id={this.props.id}
                className={`ui-navigation-item ${selected ? "selected" : ""}`}
                onClick={handleClick}
            >
                <div className={classNames("nav-label", this.props.proBadge ? "with-pro-badge" : null)}>
                    {this.props.icon && <div className="icon-container">
                        <Icon>{this.props.icon}</Icon>
                        {this.props.iconLabel && <span className="icon-label">{this.props.iconLabel}</span>}
                    </div>}
                    {this.props.image && this.props.image}
                    {this.props.title}
                </div>
                {this.props.proBadge || null}
                {React.Children.map(this.props.children, child => {
                    if (child) {
                        return React.cloneElement(child, {
                            selected: this.props.selected,
                            onSelect: this.props.onSelect
                        });
                    }
                })}
            </div>
        );
    }
}

export class Section extends Component {
    render() {
        return (
            <section id={this.props.id}>
                {
                    this.props.title &&
                    <div className="section-title">{this.props.title}{this.props.proBadge || null}</div>
                }
                { !this.props.title && <Gap5/> }
                {
                    this.props.description &&
                    <div className="section-description">{this.props.description}</div>
                }

                {this.props.children}
            </section>
        );
    }
}

export class Field extends Component {
    render() {
        return (
            <section className="field">
                {this.props.title && <div className="field-label">{this.props.title}</div> }
                {this.props.children}
            </section>
        );
    }
}

export class BlueButton extends Component {
    render() {
        return (
            <Button variant="contained" color="primary" {...this.props}>
                {this.props.children}
            </Button>
        );
    }
}

export class BlueOutlinedButton extends Component {
    render() {
        return (
            <Button variant="outlined" color="primary" {...this.props}>
                {this.props.children}
            </Button>
        );
    }
}

export class YellowButton extends Component {
    render() {
        return (
            <Button variant="contained" {...this.props} className="yellow">
                {this.props.children}
            </Button>
        );
    }
}

export class ScaryButton extends Component {
    render() {
        return (
            <Button variant="contained" {...this.props} className="orange">
                {this.props.children}
            </Button>
        );
    }
}

export class DarkButton extends Component {
    render() {
        return (
            <Button variant="contained" {...this.props} className="dark">
                {this.props.children}
            </Button>
        );
    }
}

export class TextButton extends Component {
    render() {
        return (
            <Button variant="text" {...this.props} className="transparent">
                {this.props.children}
            </Button>
        );
    }
}

export const WhiteIconButton = styled(IconButton)`
  .MuiIcon-root {
    color: white;
    transition: color 300ms;
  }
  &:hover {
    .MuiIcon-root {
        color: ${themeColors.ui_blue};
      }
  }
`;

export const RoundIconButton = styled(IconButton)`
   .MuiIcon-root {
      color: white;
      font-size: 20px;
  }
  &&&{
      background: ${themeColors.ui_blue};
      padding: 4px;
  }
`;

export const WhiteTextButton = styled(Button)`
  .MuiIcon-root {
    color: white;
  }
  .MuiButton-label {
    color: white;
  }
`;

export class IconMenu extends Component {
    state = {
        anchorEl: null
    }

    handleShowMenu = event => {
        this.setState({ anchorEl: event.currentTarget });
    }

    handleCloseMenu = () => {
        this.setState({ anchorEl: null });
    }

    handleMouseDown = event => {
        event.stopPropagation();
    }

    handleMenuItemClick = (callback, event) => {
        if (callback) {
            event.stopPropagation();
            this.handleCloseMenu();
            callback(event);
        }
    }

    render() {
        let { icon = "more_vert", ariaLabel, size = "medium", iconButtonColor = "default", disabled } = this.props;

        return (
            <Fragment>
                <IconButton
                    aria-haspopup="true"
                    aria-label={ariaLabel}
                    onClick={this.handleShowMenu}
                    color={iconButtonColor}
                    disabled={disabled}
                    size={size}
                >
                    <Icon fontSize="small">{icon}</Icon>
                </IconButton>
                <Menu
                    variant="menu"
                    anchorEl={this.state.anchorEl}
                    getContentAnchorEl={null}
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleCloseMenu}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center"
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "center"
                    }}
                >
                    {React.Children.map(this.props.children, child =>
                        child ? React.cloneElement(child, {
                            onClick: event => this.handleMenuItemClick(child.props.onClick, event),
                            onMouseDown: this.handleMouseDown
                        }) : null
                    )}
                </Menu>
            </Fragment>
        );
    }
}

export class ContextMenu extends Component {
    handleCloseMenu = () => {
        this.props.onClose && this.props.onClose();
    }

    handleMenuItemClick = (callback, event) => {
        this.handleCloseMenu();
        callback(event);
    }

    render() {
        let { x, y } = this.props;

        return (
            <Popover
                open={true}
                anchorReference="anchorPosition"
                anchorPosition={{ top: y, left: x }}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                onClose={this.handleCloseMenu}
            >
                <MenuList
                    variant="menu"
                >
                    {React.Children.map(this.props.children, child =>
                        child ? React.cloneElement(child, { onClick: event => this.handleMenuItemClick(child.props.onClick, event) }) : null
                    )}
                </MenuList>
            </Popover>
        );
    }
}

export const Divider = styled.hr`
  border: none;
  height: 1px;
  background: ${props => props.color || "#eee"};
  width: 100%;
  margin-top: ${props => props.margin != null ? props.margin : 30}px;
  margin-bottom: ${props => props.margin != null ? props.margin : 30}px;
`;
